import { render, staticRenderFns } from "./VacancyInfo.vue?vue&type=template&id=7255ae1f&"
import script from "./VacancyInfo.vue?vue&type=script&lang=js&"
export * from "./VacancyInfo.vue?vue&type=script&lang=js&"
import style0 from "./VacancyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports